// courseHistory.js
// Historical performance data for golfers at specific courses
// AUTO-GENERATED from Historical_Finishes_.xlsx

export const COURSE_HISTORY = {
  // GENESIS INVITATIONAL
  'genesis-invitational': {
    courseName: 'Riviera Country Club',
    golfers: {
      'Rahm, Jon': [
        { year: 2023, finish: '1', sg_total: 0.1 },
        { year: 2022, finish: 'T21', sg_total: 0.1 },
        { year: 2021, finish: 'T5', sg_total: 0.1 },
        { year: 2020, finish: 'T17', sg_total: 0.1 }
      ],
      'Young, Cameron': [
        { year: 2024, finish: 'T16', sg_total: 0.2 },
        { year: 2023, finish: 'T20', sg_total: 0.2 },
        { year: 2022, finish: 'T2', sg_total: 0.2 }
      ],
      'Johnson, Dustin': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T8', sg_total: 0.0 },
        { year: 2020, finish: 'T10', sg_total: 0.0 }
      ],
      'Mickelson, Phil': [
        { year: 2020, finish: 'CUT', sg_total: 0.1 }
      ],
      'Hovland, Viktor': [
        { year: 2024, finish: 'T19', sg_total: 0.1 },
        { year: 2023, finish: 'T20', sg_total: 0.1 },
        { year: 2022, finish: 'T4', sg_total: 0.1 },
        { year: 2021, finish: 'T5', sg_total: 0.1 }
      ],
      'Svensson, Adam': [
        { year: 2024, finish: 'T10', sg_total: 0.3 },
        { year: 2023, finish: 'T9', sg_total: 0.3 }
      ],
      'Zalatoris, Will': [
        { year: 2024, finish: 'T2', sg_total: 0.1 },
        { year: 2023, finish: '4', sg_total: 0.1 },
        { year: 2022, finish: 'T26', sg_total: 0.1 },
        { year: 2021, finish: 'T15', sg_total: 0.1 }
      ],
      'Morikawa, Collin': [
        { year: 2024, finish: 'T19', sg_total: 0.1 },
        { year: 2023, finish: 'T6', sg_total: 0.1 },
        { year: 2022, finish: 'T2', sg_total: 0.1 },
        { year: 2021, finish: 'T43', sg_total: 0.1 },
        { year: 2020, finish: 'T26', sg_total: 0.1 }
      ],
      'Homa, Max': [
        { year: 2024, finish: 'T16', sg_total: 0.1 },
        { year: 2023, finish: '2', sg_total: 0.1 },
        { year: 2022, finish: 'T10', sg_total: 0.1 },
        { year: 2021, finish: '1', sg_total: 0.1 },
        { year: 2020, finish: 'T5', sg_total: 0.1 }
      ],
      'Schauffele, Xander': [
        { year: 2024, finish: 'T4', sg_total: 0.1 },
        { year: 2023, finish: 'T33', sg_total: 0.1 },
        { year: 2022, finish: 'T13', sg_total: 0.1 },
        { year: 2021, finish: 'T15', sg_total: 0.1 },
        { year: 2020, finish: 'T23', sg_total: 0.1 }
      ],
      'Cantlay, Patrick': [
        { year: 2024, finish: 'T4', sg_total: 0.1 },
        { year: 2023, finish: '3', sg_total: 0.1 },
        { year: 2022, finish: 'T33', sg_total: 0.1 },
        { year: 2021, finish: 'T15', sg_total: 0.1 },
        { year: 2020, finish: 'T17', sg_total: 0.1 }
      ],
      'Stricker, Steve': [
        { year: 2020, finish: 'T56', sg_total: 0.1 }
      ],
      'McNealy, Maverick': [
        { year: 2022, finish: 'T7', sg_total: 0.3 },
        { year: 2021, finish: 'CUT', sg_total: 0.3 }
      ],
      'Scott, Adam': [
        { year: 2024, finish: 'T19', sg_total: 0.0 },
        { year: 2023, finish: '65', sg_total: 0.0 },
        { year: 2022, finish: 'T4', sg_total: 0.0 },
        { year: 2021, finish: 'T38', sg_total: 0.0 },
        { year: 2020, finish: '1', sg_total: 0.0 }
      ],
      'Pereira, Mito': [
        { year: 2022, finish: 'T15', sg_total: 0.5 }
      ],
      'MacIntyre, Robert': [
        { year: 2022, finish: 'T15', sg_total: 0.5 }
      ],
      'Cole, Eric': [
        { year: 2024, finish: 'T10', sg_total: 0.5 }
      ],
      'Matsuyama, Hideki': [
        { year: 2024, finish: '1', sg_total: 0.1 },
        { year: 2023, finish: 'CUT', sg_total: 0.1 },
        { year: 2022, finish: 'T39', sg_total: 0.1 },
        { year: 2021, finish: 'CUT', sg_total: 0.1 },
        { year: 2020, finish: 'T5', sg_total: 0.1 }
      ],
      'Mitchell, Keith': [
        { year: 2023, finish: '5', sg_total: 0.3 }
      ],
      'McIlroy, Rory': [
        { year: 2024, finish: 'T24', sg_total: 0.1 },
        { year: 2023, finish: 'T29', sg_total: 0.1 },
        { year: 2022, finish: 'T10', sg_total: 0.1 },
        { year: 2021, finish: 'CUT', sg_total: 0.1 },
        { year: 2020, finish: 'T5', sg_total: 0.1 }
      ],
      'Niemann, Joaquin': [
        { year: 2022, finish: '1', sg_total: 0.1 },
        { year: 2021, finish: 'T43', sg_total: 0.1 },
        { year: 2020, finish: 'CUT', sg_total: 0.1 }
      ],
      'Cabrera Bello, Rafa': [
        { year: 2020, finish: 'T17', sg_total: 0.1 }
      ],
      'Scheffler, Scottie': [
        { year: 2024, finish: 'T10', sg_total: 0.1 },
        { year: 2023, finish: 'T12', sg_total: 0.1 },
        { year: 2022, finish: 'T7', sg_total: 0.1 },
        { year: 2021, finish: 'T20', sg_total: 0.1 },
        { year: 2020, finish: 'T30', sg_total: 0.1 }
      ],
      'Garcia, Sergio': [
        { year: 2022, finish: 'T39', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T37', sg_total: 0.0 }
      ],
      'Watson, Bubba': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Fleetwood, Tommy': [
        { year: 2024, finish: 'T10', sg_total: 0.1 },
        { year: 2023, finish: 'T20', sg_total: 0.1 }
      ],
      'Furyk, Jim': [
        { year: 2021, finish: 'T26', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Ortiz, Carlos': [
        { year: 2022, finish: 'T39', sg_total: 0.1 },
        { year: 2021, finish: 'CUT', sg_total: 0.1 },
        { year: 2020, finish: 'T26', sg_total: 0.1 }
      ],
      'Holmes, J.B.': [
        { year: 2023, finish: 'T67', sg_total: 0.0 },
        { year: 2021, finish: 'T57', sg_total: 0.0 },
        { year: 2020, finish: 'T51', sg_total: 0.0 }
      ],
      'Tringale, Cameron': [
        { year: 2022, finish: 'T13', sg_total: 0.0 },
        { year: 2021, finish: 'T26', sg_total: 0.0 },
        { year: 2020, finish: 'T30', sg_total: 0.0 }
      ],
      'Donald, Luke': [
        { year: 2023, finish: 'T40', sg_total: 0.0 }
      ],
      'List, Luke': [
        { year: 2024, finish: 'T2', sg_total: 0.0 },
        { year: 2023, finish: 'T29', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T30', sg_total: 0.0 }
      ],
      'Aberg, Ludvig': [
        { year: 2024, finish: 'T19', sg_total: 0.3 }
      ],
      'Finau, Tony': [
        { year: 2024, finish: 'T19', sg_total: 0.0 },
        { year: 2023, finish: 'T20', sg_total: 0.0 },
        { year: 2022, finish: 'T33', sg_total: 0.0 },
        { year: 2021, finish: '2', sg_total: 0.0 },
        { year: 2020, finish: 'T51', sg_total: 0.0 }
      ],
      'Casey, Paul': [
        { year: 2022, finish: 'T15', sg_total: 0.0 },
        { year: 2020, finish: 'T37', sg_total: 0.0 }
      ],
      'Hodges, Lee': [
        { year: 2024, finish: 'T24', sg_total: 0.1 },
        { year: 2023, finish: 'T18', sg_total: 0.1 },
        { year: 2022, finish: 'T39', sg_total: 0.1 }
      ],
      'Munoz, Sebastian': [
        { year: 2022, finish: 'T21', sg_total: 0.1 },
        { year: 2021, finish: 'T43', sg_total: 0.1 },
        { year: 2020, finish: 'T26', sg_total: 0.1 }
      ],
      'Kuchar, Matt': [
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: '8', sg_total: 0.0 },
        { year: 2022, finish: 'T67', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T2', sg_total: 0.0 }
      ],
      'DeChambeau, Bryson': [
        { year: 2021, finish: 'CUT', sg_total: 0.1 },
        { year: 2020, finish: 'T5', sg_total: 0.1 }
      ],
      'Baddeley, Aaron': [
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'English, Harris': [
        { year: 2024, finish: '7', sg_total: 0.0 },
        { year: 2023, finish: 'T12', sg_total: 0.0 }
      ],
      'Smith, Cameron': [
        { year: 2022, finish: 'T33', sg_total: 0.0 },
        { year: 2021, finish: '4', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Gooch, Talor': [
        { year: 2022, finish: 'CUT', sg_total: 0.1 },
        { year: 2021, finish: 'T12', sg_total: 0.1 },
        { year: 2020, finish: 'T10', sg_total: 0.1 }
      ],
      'Theegala, Sahith': [
        { year: 2024, finish: 'T37', sg_total: 0.1 },
        { year: 2023, finish: 'T6', sg_total: 0.1 },
        { year: 2022, finish: 'T48', sg_total: 0.1 }
      ],
      'Thomas, Justin': [
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'T20', sg_total: 0.0 },
        { year: 2022, finish: '6', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Spieth, Jordan': [
        { year: 2024, finish: 'DQ', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T26', sg_total: 0.0 },
        { year: 2021, finish: 'T15', sg_total: 0.0 },
        { year: 2020, finish: 'T59', sg_total: 0.0 }
      ],
      'Willett, Danny': [
        { year: 2023, finish: 'T18', sg_total: 0.1 },
        { year: 2020, finish: 'CUT', sg_total: 0.1 }
      ],
      'Poston, J.T.': [
        { year: 2024, finish: 'T10', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T43', sg_total: 0.0 },
        { year: 2020, finish: 'T30', sg_total: 0.0 }
      ],
      'Hahn, James': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T61', sg_total: 0.0 },
        { year: 2021, finish: 'T15', sg_total: 0.0 },
        { year: 2020, finish: 'T13', sg_total: 0.0 }
      ],
      'Hoag, Bo': [
        { year: 2021, finish: 'T32', sg_total: 0.3 }
      ],
      'Detry, Thomas': [
        { year: 2023, finish: 'T33', sg_total: 0.3 }
      ],
      'Kim, S.H.': [
        { year: 2023, finish: 'T33', sg_total: 0.3 }
      ],
      'Leishman, Marc': [
        { year: 2022, finish: 'T15', sg_total: 0.0 },
        { year: 2021, finish: 'T32', sg_total: 0.0 },
        { year: 2020, finish: 'T43', sg_total: 0.0 }
      ],
      'Brown, Scott': [
        { year: 2020, finish: 'T2', sg_total: 0.0 }
      ],
      'Griffin, Lanto': [
        { year: 2023, finish: 'WD', sg_total: 0.1 },
        { year: 2022, finish: 'T39', sg_total: 0.1 },
        { year: 2021, finish: 'T26', sg_total: 0.1 },
        { year: 2020, finish: 'T37', sg_total: 0.1 }
      ],
      'Rose, Justin': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T56', sg_total: 0.0 }
      ],
      'Moore, Ryan': [
        { year: 2020, finish: 'T30', sg_total: 0.0 }
      ],
      'Bryan, Wesley': [
        { year: 2021, finish: 'T43', sg_total: 0.1 }
      ],
      'An, Byeong Hun': [
        { year: 2024, finish: 'T16', sg_total: 0.1 }
      ],
      'Harrington, Scott': [
        { year: 2021, finish: 'T26', sg_total: 0.1 }
      ],
      'Hadwin, Adam': [
        { year: 2024, finish: 'T4', sg_total: 0.0 },
        { year: 2023, finish: '66', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T26', sg_total: 0.0 },
        { year: 2020, finish: 'T26', sg_total: 0.0 }
      ],
      'Kokrak, Jason': [
        { year: 2022, finish: 'T26', sg_total: 0.0 },
        { year: 2021, finish: 'T32', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Clark, Wyndham': [
        { year: 2024, finish: 'CUT', sg_total: 0.1 },
        { year: 2023, finish: 'T33', sg_total: 0.1 },
        { year: 2022, finish: 'DQ', sg_total: 0.1 },
        { year: 2021, finish: 'T8', sg_total: 0.1 },
        { year: 2020, finish: 'T17', sg_total: 0.1 }
      ],
      'Pan, C.T.': [
        { year: 2022, finish: '9', sg_total: 0.1 },
        { year: 2021, finish: 'T20', sg_total: 0.1 },
        { year: 2020, finish: 'CUT', sg_total: 0.1 }
      ],
      'Moore, Taylor': [
        { year: 2024, finish: 'T31', sg_total: 0.1 },
        { year: 2023, finish: 'CUT', sg_total: 0.1 },
        { year: 2022, finish: 'T21', sg_total: 0.1 }
      ],
      'Fitzpatrick, Matt': [
        { year: 2024, finish: 'CUT', sg_total: 0.1 },
        { year: 2023, finish: 'CUT', sg_total: 0.1 },
        { year: 2021, finish: 'T5', sg_total: 0.1 },
        { year: 2020, finish: 'T30', sg_total: 0.1 }
      ],
      'Sabbatini, Rory': [
        { year: 2020, finish: 'T59', sg_total: 0.0 }
      ],
      'Bradley, Keegan': [
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T48', sg_total: 0.0 },
        { year: 2021, finish: 'T60', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Noren, Alex': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T48', sg_total: 0.0 },
        { year: 2021, finish: 'T12', sg_total: 0.0 },
        { year: 2020, finish: 'T59', sg_total: 0.0 }
      ],
      'Kim, Tom': [
        { year: 2024, finish: 'T24', sg_total: 0.1 },
        { year: 2023, finish: 'T45', sg_total: 0.1 }
      ],
      'Suh, Justin': [
        { year: 2023, finish: 'T40', sg_total: 0.2 }
      ],
      'Taylor, Vaughn': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T13', sg_total: 0.0 }
      ],
      'Rodgers, Patrick': [
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T12', sg_total: 0.0 },
        { year: 2020, finish: 'T30', sg_total: 0.0 }
      ],
      'Burns, Sam': [
        { year: 2024, finish: 'T10', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: '3', sg_total: 0.0 },
        { year: 2020, finish: 'T23', sg_total: 0.0 }
      ],
      'Hoge, Tom': [
        { year: 2024, finish: '8', sg_total: 0.0 },
        { year: 2023, finish: 'T14', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T52', sg_total: 0.0 }
      ],
      'Kang, Sung': [
        { year: 2021, finish: '67', sg_total: 0.0 },
        { year: 2020, finish: 'T2', sg_total: 0.0 }
      ],
      'Rai, Aaron': [
        { year: 2023, finish: 'T29', sg_total: 0.1 },
        { year: 2022, finish: 'T61', sg_total: 0.1 }
      ],
      'Cink, Stewart': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Jones, Matt': [
        { year: 2022, finish: 'T15', sg_total: 0.0 },
        { year: 2021, finish: 'T8', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Walker, Jimmy': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Taylor, Nick': [
        { year: 2024, finish: 'T39', sg_total: 0.0 },
        { year: 2023, finish: 'T33', sg_total: 0.0 },
        { year: 2021, finish: 'T20', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Pieters, Thomas': [
        { year: 2022, finish: 'CUT', sg_total: 0.1 }
      ],
      'Hossler, Beau': [
        { year: 2024, finish: 'T24', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T48', sg_total: 0.0 }
      ],
      'Henley, Russell': [
        { year: 2024, finish: 'T24', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T33', sg_total: 0.0 },
        { year: 2021, finish: 'T38', sg_total: 0.0 },
        { year: 2020, finish: 'T17', sg_total: 0.0 }
      ],
      'Straka, Sepp': [
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'T45', sg_total: 0.0 },
        { year: 2022, finish: 'T15', sg_total: 0.0 },
        { year: 2021, finish: 'T43', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Woods, Tiger': [
        { year: 2024, finish: 'WD', sg_total: 0.0 },
        { year: 2023, finish: 'T45', sg_total: 0.0 },
        { year: 2020, finish: '68', sg_total: 0.0 }
      ],
      'Meronk, Adrian': [
        { year: 2023, finish: 'T45', sg_total: 0.1 }
      ],
      'Fowler, Rickie': [
        { year: 2024, finish: 'T35', sg_total: 0.0 },
        { year: 2023, finish: 'T20', sg_total: 0.0 },
        { year: 2022, finish: 'T55', sg_total: 0.0 },
        { year: 2021, finish: 'T20', sg_total: 0.0 }
      ],
      'Lee, K.H.': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T26', sg_total: 0.0 },
        { year: 2021, finish: '66', sg_total: 0.0 },
        { year: 2020, finish: 'T13', sg_total: 0.0 }
      ],
      'Trainer, Martin': [
        { year: 2020, finish: 'T47', sg_total: 0.1 }
      ],
      'Na, Kevin': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T38', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Frittelli, Dylan': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T26', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'McCarthy, Denny': [
        { year: 2024, finish: 'T39', sg_total: 0.0 },
        { year: 2023, finish: 'T14', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T37', sg_total: 0.0 }
      ],
      'Power, Seamus': [
        { year: 2024, finish: 'T31', sg_total: 0.0 },
        { year: 2023, finish: 'T14', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 }
      ],
      'Todd, Brendon': [
        { year: 2024, finish: 'T31', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T56', sg_total: 0.0 }
      ],
      'Harrington, Padraig': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Lowry, Shane': [
        { year: 2023, finish: 'T14', sg_total: 0.0 }
      ],
      'McCumber, Tyler': [
        { year: 2021, finish: 'T52', sg_total: 0.1 }
      ],
      'Griffin, Ben': [
        { year: 2024, finish: 'T37', sg_total: 0.1 }
      ],
      'Schwartzel, Charl': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T62', sg_total: 0.0 }
      ],
      'Schwab, Matthias': [
        { year: 2023, finish: 'T50', sg_total: 0.1 }
      ],
      'Laird, Martin': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T39', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T43', sg_total: 0.0 }
      ],
      'Van Rooyen, Erik': [
        { year: 2022, finish: 'T39', sg_total: 0.1 },
        { year: 2020, finish: 'CUT', sg_total: 0.1 }
      ],
      'Perez, Pat': [
        { year: 2022, finish: 'T39', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T47', sg_total: 0.0 }
      ],
      'Lashley, Nate': [
        { year: 2023, finish: 'T20', sg_total: 0.0 },
        { year: 2021, finish: 'T57', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Woodland, Gary': [
        { year: 2024, finish: 'T39', sg_total: 0.0 },
        { year: 2023, finish: 'T9', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Hoffman, Charley': [
        { year: 2024, finish: '50', sg_total: 0.0 },
        { year: 2022, finish: '71', sg_total: 0.0 },
        { year: 2021, finish: 'T52', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Watney, Nick': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T55', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Grace, Branden': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T20', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Steele, Brendan': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T43', sg_total: 0.0 }
      ],
      'Cook, Austin': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Howell III, Charles': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T59', sg_total: 0.0 }
      ],
      'Day, Jason': [
        { year: 2024, finish: '9', sg_total: 0.0 },
        { year: 2023, finish: 'T9', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Malnati, Peter': [
        { year: 2023, finish: 'T20', sg_total: 0.0 },
        { year: 2022, finish: 'T26', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Ryder, Sam': [
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'T20', sg_total: 0.0 },
        { year: 2022, finish: 'T26', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Stuard, Brian': [
        { year: 2022, finish: 'T61', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T23', sg_total: 0.0 }
      ],
      'Ancer, Abraham': [
        { year: 2022, finish: 'T39', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T43', sg_total: 0.0 }
      ],
      'NeSmith, Matt': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T55', sg_total: 0.0 },
        { year: 2021, finish: 'T20', sg_total: 0.0 }
      ],
      'Snedeker, Brandt': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Chappell, Kevin': [
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Harman, Brian': [
        { year: 2024, finish: 'T44', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T43', sg_total: 0.0 },
        { year: 2020, finish: 'T47', sg_total: 0.0 }
      ],
      'Werenski, Richy': [
        { year: 2021, finish: 'T57', sg_total: 0.0 }
      ],
      'Hojgaard, Nicolai': [
        { year: 2024, finish: 'T39', sg_total: 0.0 }
      ],
      'Varner III, Harold': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T62', sg_total: 0.0 },
        { year: 2020, finish: 'T13', sg_total: 0.0 }
      ],
      'Hughes, Mackenzie': [
        { year: 2024, finish: 'T31', sg_total: 0.0 },
        { year: 2023, finish: 'T50', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T32', sg_total: 0.0 }
      ],
      'Cauley, Bud': [
        { year: 2020, finish: 'T51', sg_total: 0.0 }
      ],
      'Kim, Si Woo': [
        { year: 2024, finish: 'T44', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: '73', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 },
        { year: 2020, finish: 'T37', sg_total: 0.0 }
      ],
      'Hatton, Tyrrell': [
        { year: 2023, finish: 'T40', sg_total: 0.0 }
      ],
      'Im, Sungjae': [
        { year: 2024, finish: 'T44', sg_total: 0.0 },
        { year: 2023, finish: 'T56', sg_total: 0.0 },
        { year: 2022, finish: 'T33', sg_total: 0.0 },
        { year: 2020, finish: 'CUT', sg_total: 0.0 }
      ],
      'Conners, Corey': [
        { year: 2024, finish: 'T24', sg_total: -0.0 },
        { year: 2023, finish: '61', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Hickok, Kramer': [
        { year: 2023, finish: 'T29', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 }
      ],
      'Stanley, Kyle': [
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'T32', sg_total: -0.0 },
        { year: 2020, finish: 'T64', sg_total: -0.0 }
      ],
      'Thompson, Michael': [
        { year: 2023, finish: 'T45', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Glover, Lucas': [
        { year: 2024, finish: 'T35', sg_total: -0.0 },
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Vegas, Jhonattan': [
        { year: 2023, finish: 'T56', sg_total: -0.0 },
        { year: 2022, finish: 'T55', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Koepka, Brooks': [
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'T38', sg_total: -0.0 },
        { year: 2020, finish: 'T43', sg_total: -0.0 }
      ],
      'Kitayama, Kurt': [
        { year: 2024, finish: 'T39', sg_total: -0.0 },
        { year: 2023, finish: 'CUT', sg_total: -0.0 }
      ],
      'Stallings, Scott': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Every, Matt': [
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Bezuidenhout, Christiaan': [
        { year: 2024, finish: 'T24', sg_total: -0.0 },
        { year: 2023, finish: 'T58', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 }
      ],
      'Lebioda, Hank': [
        { year: 2022, finish: 'T67', sg_total: -0.0 }
      ],
      'Kraft, Kelly': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 }
      ],
      'Herbert, Lucas': [
        { year: 2023, finish: 'T58', sg_total: -0.0 }
      ],
      'Taylor, Ben': [
        { year: 2023, finish: 'T58', sg_total: -0.0 }
      ],
      'Tway, Kevin': [
        { year: 2023, finish: 'T40', sg_total: -0.0 },
        { year: 2022, finish: 'T48', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Putnam, Andrew': [
        { year: 2024, finish: 'T44', sg_total: -0.0 },
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T48', sg_total: -0.0 },
        { year: 2021, finish: 'T32', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Davis, Cam': [
        { year: 2024, finish: '49', sg_total: -0.0 },
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T48', sg_total: -0.0 },
        { year: 2021, finish: 'T43', sg_total: -0.0 }
      ],
      'Villegas, Camilo': [
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Lahiri, Anirban': [
        { year: 2022, finish: 'CUT', sg_total: -0.0 }
      ],
      'Streelman, Kevin': [
        { year: 2023, finish: 'T50', sg_total: -0.0 },
        { year: 2021, finish: 'T52', sg_total: -0.0 }
      ],
      'Merritt, Troy': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Molinari, Francesco': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T55', sg_total: -0.0 },
        { year: 2021, finish: 'T8', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Redman, Doc': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T61', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Grillo, Emiliano': [
        { year: 2024, finish: 'T44', sg_total: -0.0 },
        { year: 2023, finish: 'T67', sg_total: -0.0 },
        { year: 2022, finish: 'T21', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Schenk, Adam': [
        { year: 2024, finish: 'CUT', sg_total: -0.0 },
        { year: 2023, finish: 'T50', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'T47', sg_total: -0.0 }
      ],
      'Lower, Justin': [
        { year: 2023, finish: 'CUT', sg_total: -0.2 }
      ],
      'Nakajima, Keita': [
        { year: 2023, finish: 'CUT', sg_total: -0.2 }
      ],
      'Kizzire, Patton': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T61', sg_total: -0.0 }
      ],
      'Palmer, Ryan': [
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: '67', sg_total: -0.0 }
      ],
      'Dufner, Jason': [
        { year: 2020, finish: 'T64', sg_total: -0.0 }
      ],
      'Landry, Andrew': [
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'T26', sg_total: -0.0 },
        { year: 2020, finish: 'T37', sg_total: -0.0 }
      ],
      'Whaley, Vince': [
        { year: 2022, finish: 'CUT', sg_total: -0.2 }
      ],
      'Lee, Danny': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T21', sg_total: -0.0 },
        { year: 2021, finish: 'T52', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Reavie, Chez': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T10', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'T10', sg_total: -0.0 }
      ],
      'Higgs, Harry': [
        { year: 2022, finish: 'T55', sg_total: -0.1 },
        { year: 2021, finish: 'CUT', sg_total: -0.1 }
      ],
      'Piercy, Scott': [
        { year: 2023, finish: 'T50', sg_total: -0.0 },
        { year: 2022, finish: 'T61', sg_total: -0.0 },
        { year: 2021, finish: 'T64', sg_total: -0.0 },
        { year: 2020, finish: 'T17', sg_total: -0.0 }
      ],
      'Dahmen, Joel': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: '74', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'T5', sg_total: -0.0 }
      ],
      'Bramlett, Joseph': [
        { year: 2020, finish: 'T51', sg_total: -0.1 }
      ],
      'Knox, Russell': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T33', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Reed, Patrick': [
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2020, finish: 'T51', sg_total: -0.0 }
      ],
      'Kim, Tae Hoon': [
        { year: 2021, finish: 'CUT', sg_total: -0.3 }
      ],
      'Kirk, Chris': [
        { year: 2024, finish: 'CUT', sg_total: -0.1 }
      ],
      'Hubbard, Mark': [
        { year: 2023, finish: 'CUT', sg_total: -0.1 },
        { year: 2021, finish: 'CUT', sg_total: -0.1 }
      ],
      'Gay, Brian': [
        { year: 2021, finish: 'T60', sg_total: -0.0 },
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Mullinax, Trey': [
        { year: 2023, finish: 'T62', sg_total: -0.2 }
      ],
      'Duncan, Tyler': [
        { year: 2023, finish: 'T33', sg_total: -0.0 },
        { year: 2021, finish: 'T38', sg_total: -0.0 },
        { year: 2020, finish: 'T64', sg_total: -0.0 }
      ],
      'Jaeger, Stephan': [
        { year: 2023, finish: 'T40', sg_total: -0.1 }
      ],
      'Long, Adam': [
        { year: 2023, finish: 'T50', sg_total: -0.1 },
        { year: 2022, finish: '75', sg_total: -0.1 },
        { year: 2021, finish: 'CUT', sg_total: -0.1 },
        { year: 2020, finish: 'CUT', sg_total: -0.1 }
      ],
      'Lipsky, David': [
        { year: 2023, finish: 'T62', sg_total: -0.1 },
        { year: 2022, finish: 'CUT', sg_total: -0.1 }
      ],
      'Stroud, Chris': [
        { year: 2020, finish: 'CUT', sg_total: -0.0 }
      ],
      'Wise, Aaron': [
        { year: 2022, finish: 'T67', sg_total: -0.1 },
        { year: 2020, finish: 'CUT', sg_total: -0.1 }
      ],
      'Smotherman, Austin': [
        { year: 2023, finish: 'CUT', sg_total: -0.4 }
      ],
      'McGreevy, Max': [
        { year: 2023, finish: 'CUT', sg_total: -0.4 }
      ],
      'Armour, Ryan': [
        { year: 2021, finish: 'CUT', sg_total: -0.1 },
        { year: 2020, finish: 'CUT', sg_total: -0.1 }
      ],
      'Smalley, Alex': [
        { year: 2024, finish: 'CUT', sg_total: -0.1 },
        { year: 2023, finish: 'CUT', sg_total: -0.1 },
        { year: 2022, finish: '72', sg_total: -0.1 }
      ],
      'Brennan, Michael': [
        { year: 2022, finish: 'CUT', sg_total: -0.5 }
      ],
      'Horschel, Billy': [
        { year: 2023, finish: 'CUT', sg_total: -0.1 }
      ],
      'Aphibarnrat, Kiradech': [
        { year: 2020, finish: 'CUT', sg_total: -0.2 }
      ],
      'Streb, Robert': [
        { year: 2023, finish: 'CUT', sg_total: -0.1 },
        { year: 2022, finish: 'CUT', sg_total: -0.1 },
        { year: 2021, finish: 'CUT', sg_total: -0.1 }
      ],
      'Wolff, Matthew': [
        { year: 2021, finish: 'T64', sg_total: -0.2 },
        { year: 2020, finish: 'CUT', sg_total: -0.2 }
      ],
      'Ghim, Doug': [
        { year: 2023, finish: 'T62', sg_total: -0.1 },
        { year: 2022, finish: 'CUT', sg_total: -0.1 },
        { year: 2021, finish: 'CUT', sg_total: -0.1 }
      ],
      'Champ, Cameron': [
        { year: 2023, finish: 'CUT', sg_total: -0.1 },
        { year: 2022, finish: 'T67', sg_total: -0.1 },
        { year: 2020, finish: 'CUT', sg_total: -0.1 }
      ],
      'Montgomery, Taylor': [
        { year: 2024, finish: 'CUT', sg_total: -0.3 },
        { year: 2023, finish: 'CUT', sg_total: -0.3 }
      ],
      'Ramey, Chad': [
        { year: 2023, finish: 'CUT', sg_total: -0.7 }
      ],
      'Wu, Brandon': [
        { year: 2023, finish: 'CUT', sg_total: -0.7 }
      ],
      'Thompson, Davis': [
        { year: 2023, finish: 'CUT', sg_total: -0.7 }
      ],
      'Pendrith, Taylor': [
        { year: 2022, finish: 'CUT', sg_total: -0.7 }
      ],
      'Hagy, Brandon': [
        { year: 2022, finish: 'CUT', sg_total: -0.7 }
      ],
      'Lee, Jaekyeong': [
        { year: 2022, finish: 'CUT', sg_total: -0.7 }
      ],
      'Johnson, Chase': [
        { year: 2024, finish: '51', sg_total: -0.4 }
      ],
      'Norlander, Henrik': [
        { year: 2022, finish: 'CUT', sg_total: -0.4 },
        { year: 2021, finish: 'CUT', sg_total: -0.4 }
      ],
      'Dunlap, Nick': [
        { year: 2024, finish: 'CUT', sg_total: -0.8 }
      ],
      'Spaun, J.J.': [
        { year: 2024, finish: 'CUT', sg_total: -0.1 },
        { year: 2023, finish: 'T33', sg_total: -0.1 },
        { year: 2022, finish: 'CUT', sg_total: -0.1 },
        { year: 2020, finish: '63', sg_total: -0.1 }
      ],
      'Shelton, Robby': [
        { year: 2021, finish: 'CUT', sg_total: -0.8 }
      ],
      'Mack III, Willie': [
        { year: 2021, finish: 'CUT', sg_total: -0.8 }
      ],
      'Herman, Jim': [
        { year: 2021, finish: 'CUT', sg_total: -0.2 },
        { year: 2020, finish: 'CUT', sg_total: -0.2 }
      ],
      'Burgoon, Bronson': [
        { year: 2020, finish: 'CUT', sg_total: -0.3 }
      ],
      'Buckley, Hayden': [
        { year: 2023, finish: 'CUT', sg_total: -0.9 }
      ],
      'Hardy, Nick': [
        { year: 2024, finish: 'CUT', sg_total: -0.5 },
        { year: 2023, finish: 'CUT', sg_total: -0.5 }
      ],
      'Augenstein, John': [
        { year: 2021, finish: 'CUT', sg_total: -1.0 }
      ],
      'Hadley, Chesson': [
        { year: 2023, finish: 'CUT', sg_total: -0.3 },
        { year: 2022, finish: 'CUT', sg_total: -0.3 }
      ],
      'Brehm, Ryan': [
        { year: 2023, finish: 'CUT', sg_total: -1.2 }
      ],
      'Byrd, Marcus': [
        { year: 2023, finish: 'CUT', sg_total: -1.2 }
      ],
      'Lee, Min Woo': [
        { year: 2022, finish: 'CUT', sg_total: -1.2 }
      ],
      'Murray, Grayson': [
        { year: 2024, finish: 'CUT', sg_total: -0.4 }
      ],
      'Zhang, Xinjun': [
        { year: 2021, finish: 'CUT', sg_total: -0.6 }
      ],
      'Sigg, Greyson': [
        { year: 2023, finish: 'CUT', sg_total: -1.4 }
      ],
      'Kisner, Kevin': [
        { year: 2023, finish: 'CUT', sg_total: -0.7 }
      ],
      'Widing, Tim': [
        { year: 2021, finish: 'CUT', sg_total: -1.5 }
      ],
      'Sloan, Roger': [
        { year: 2022, finish: 'CUT', sg_total: -0.8 },
        { year: 2020, finish: 'CUT', sg_total: -0.8 }
      ],
      'Wallace, Matt': [
        { year: 2023, finish: 'CUT', sg_total: -0.8 },
        { year: 2022, finish: 'CUT', sg_total: -0.8 }
      ],
      'Kim, Yeongsu': [
        { year: 2023, finish: 'CUT', sg_total: -1.9 }
      ],
      'Yu, Kevin': [
        { year: 2024, finish: 'CUT', sg_total: -2.0 }
      ],
      'Moon, Kyongjun': [
        { year: 2020, finish: 'CUT', sg_total: -2.2 }
      ],
      'Tarren, Callum': [
        { year: 2023, finish: 'CUT', sg_total: -2.2 }
      ],
      'Flanagan, Angus': [
        { year: 2021, finish: 'CUT', sg_total: -2.5 }
      ]
    }
  },

  // ARNOLD PALMER INVITATIONAL
  'arnold-palmer-invitational': {
    courseName: 'Bay Hill Club & Lodge',
    golfers: {
      'Coody, Pierceson': [
        { year: 2023, finish: 'T14', sg_total: 0.5 }
      ],
      'Fox, Ryan': [
        { year: 2023, finish: 'T14', sg_total: 0.5 }
      ],
      'Kim, Michael': [
        { year: 2025, finish: '4', sg_total: 0.2 }
      ],
      'Herbert, Lucas': [
        { year: 2023, finish: 'CUT', sg_total: 0.3 },
        { year: 2022, finish: 'T7', sg_total: 0.3 }
      ],
      'Westmoreland, Kyle': [
        { year: 2023, finish: 'T39', sg_total: 0.2 }
      ],
      'DeChambeau, Bryson': [
        { year: 2021, finish: '1', sg_total: 0.1 }
      ],
      'Bridgeman, Jacob': [
        { year: 2025, finish: 'T15', sg_total: 0.5 }
      ],
      'Ventura, Kris': [
        { year: 2021, finish: 'T36', sg_total: 0.2 }
      ],
      'Pak, John': [
        { year: 2022, finish: 'T52', sg_total: 0.1 }
      ],
      'Gooch, Talor': [
        { year: 2022, finish: 'T7', sg_total: 0.1 },
        { year: 2021, finish: 'T43', sg_total: 0.1 }
      ],
      'Spieth, Jordan': [
        { year: 2024, finish: 'T30', sg_total: 0.2 },
        { year: 2023, finish: 'T4', sg_total: 0.2 },
        { year: 2021, finish: 'T4', sg_total: 0.2 }
      ],
      'Molinari, Francesco': [
        { year: 2023, finish: 'T14', sg_total: 0.1 },
        { year: 2021, finish: 'CUT', sg_total: 0.1 }
      ],
      'Grillo, Emiliano': [
        { year: 2024, finish: 'T8', sg_total: 0.1 },
        { year: 2023, finish: 'T39', sg_total: 0.1 },
        { year: 2021, finish: 'T21', sg_total: 0.1 }
      ],
      'Scheffler, Scottie': [
        { year: 2025, finish: 'T11', sg_total: 0.2 },
        { year: 2024, finish: '1', sg_total: 0.2 },
        { year: 2023, finish: 'T4', sg_total: 0.2 },
        { year: 2022, finish: '1', sg_total: 0.2 }
      ],
      'Mullinax, Trey': [
        { year: 2023, finish: 'T8', sg_total: 0.2 },
        { year: 2022, finish: 'CUT', sg_total: 0.2 }
      ],
      'Hoag, Bo': [
        { year: 2021, finish: 'T26', sg_total: 0.4 }
      ],
      'Conners, Corey': [
        { year: 2025, finish: '3', sg_total: 0.1 },
        { year: 2024, finish: 'T18', sg_total: 0.1 },
        { year: 2023, finish: 'T21', sg_total: 0.1 },
        { year: 2022, finish: 'T11', sg_total: 0.1 },
        { year: 2021, finish: '3', sg_total: 0.1 }
      ],
      'Riley, Davis': [
        { year: 2023, finish: 'T8', sg_total: 0.2 },
        { year: 2022, finish: 'CUT', sg_total: 0.2 }
      ],
      'Long, Adam': [
        { year: 2022, finish: 'T32', sg_total: 0.1 },
        { year: 2021, finish: 'CUT', sg_total: 0.1 }
      ],
      'Putnam, Andrew': [
        { year: 2024, finish: 'T8', sg_total: 0.1 },
        { year: 2023, finish: 'T34', sg_total: 0.1 },
        { year: 2022, finish: 'CUT', sg_total: 0.1 },
        { year: 2021, finish: 'T4', sg_total: 0.1 }
      ],
      'Mitchell, Keith': [
        { year: 2023, finish: 'T24', sg_total: 0.1 },
        { year: 2022, finish: 'T61', sg_total: 0.1 },
        { year: 2021, finish: 'T43', sg_total: 0.1 }
      ],
      'Hammer, Cole': [
        { year: 2023, finish: 'T65', sg_total: 0.0 }
      ],
      'Wallace, Matt': [
        { year: 2022, finish: 'CUT', sg_total: 0.1 },
        { year: 2021, finish: 'T18', sg_total: 0.1 }
      ],
      'Stenson, Henrik': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Hatton, Tyrrell': [
        { year: 2023, finish: 'T4', sg_total: 0.1 },
        { year: 2022, finish: 'T2', sg_total: 0.1 },
        { year: 2021, finish: 'T21', sg_total: 0.1 }
      ],
      'Every, Matt': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Werenski, Richy': [
        { year: 2021, finish: 'T4', sg_total: 0.2 }
      ],
      'Kitayama, Kurt': [
        { year: 2024, finish: 'CUT', sg_total: 0.2 },
        { year: 2023, finish: '1', sg_total: 0.2 }
      ],
      'Merritt, Troy': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T74', sg_total: 0.0 }
      ],
      'Im, Sungjae': [
        { year: 2025, finish: 'T19', sg_total: 0.1 },
        { year: 2024, finish: 'T18', sg_total: 0.1 },
        { year: 2023, finish: 'T21', sg_total: 0.1 },
        { year: 2022, finish: 'T20', sg_total: 0.1 },
        { year: 2021, finish: 'T21', sg_total: 0.1 }
      ],
      'Kang, Sung': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      "O'Hair, Sean": [
        { year: 2022, finish: 'CUT', sg_total: 0.0 }
      ],
      'Kokrak, Jason': [
        { year: 2022, finish: 'T26', sg_total: 0.0 },
        { year: 2021, finish: 'T8', sg_total: 0.0 }
      ],
      'Fitzpatrick, Matt': [
        { year: 2025, finish: 'T22', sg_total: 0.0 },
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'T14', sg_total: 0.0 },
        { year: 2022, finish: 'T9', sg_total: 0.0 },
        { year: 2021, finish: 'T10', sg_total: 0.0 }
      ],
      'MacIntyre, Robert': [
        { year: 2025, finish: 'T11', sg_total: 0.2 },
        { year: 2021, finish: 'T36', sg_total: 0.2 }
      ],
      'Schenk, Adam': [
        { year: 2024, finish: 'CUT', sg_total: 0.1 },
        { year: 2023, finish: 'T31', sg_total: 0.1 },
        { year: 2022, finish: 'T42', sg_total: 0.1 }
      ],
      'Homa, Max': [
        { year: 2025, finish: 'CUT', sg_total: 0.1 },
        { year: 2024, finish: 'T8', sg_total: 0.1 },
        { year: 2023, finish: 'T14', sg_total: 0.1 },
        { year: 2022, finish: 'T17', sg_total: 0.1 },
        { year: 2021, finish: 'T10', sg_total: 0.1 }
      ],
      'Leishman, Marc': [
        { year: 2022, finish: 'T68', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Bezuidenhout, Christiaan': [
        { year: 2025, finish: 'T19', sg_total: 0.1 },
        { year: 2024, finish: 'T44', sg_total: 0.1 },
        { year: 2023, finish: 'CUT', sg_total: 0.1 },
        { year: 2022, finish: 'T20', sg_total: 0.1 },
        { year: 2021, finish: '7', sg_total: 0.1 }
      ],
      'Lipsky, David': [
        { year: 2023, finish: 'T65', sg_total: 0.1 },
        { year: 2022, finish: 'T26', sg_total: 0.1 }
      ],
      'McDowell, Graeme': [
        { year: 2022, finish: 'T13', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Kirk, Chris': [
        { year: 2025, finish: 'T22', sg_total: 0.0 },
        { year: 2024, finish: 'T44', sg_total: 0.0 },
        { year: 2023, finish: 'T39', sg_total: 0.0 },
        { year: 2022, finish: 'T5', sg_total: 0.0 },
        { year: 2021, finish: 'T8', sg_total: 0.0 }
      ],
      'Hoge, Tom': [
        { year: 2025, finish: 'T40', sg_total: 0.0 },
        { year: 2024, finish: 'T12', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T32', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Bradley, Keegan': [
        { year: 2025, finish: 'T5', sg_total: 0.0 },
        { year: 2024, finish: 'T36', sg_total: 0.0 },
        { year: 2023, finish: 'T10', sg_total: 0.0 },
        { year: 2022, finish: 'T11', sg_total: 0.0 },
        { year: 2021, finish: 'T10', sg_total: 0.0 }
      ],
      'Willett, Danny': [
        { year: 2023, finish: 'T34', sg_total: 0.0 },
        { year: 2022, finish: 'T52', sg_total: 0.0 },
        { year: 2021, finish: 'T31', sg_total: 0.0 }
      ],
      'Kim, S.H.': [
        { year: 2023, finish: 'T39', sg_total: 0.2 }
      ],
      'Lee, Danny': [
        { year: 2022, finish: 'T61', sg_total: 0.0 },
        { year: 2021, finish: 'T49', sg_total: 0.0 }
      ],
      'Taylor, Ben': [
        { year: 2023, finish: 'T53', sg_total: 0.1 }
      ],
      'Baddeley, Aaron': [
        { year: 2023, finish: 'T34', sg_total: 0.0 }
      ],
      'Garcia, Sergio': [
        { year: 2022, finish: 'T38', sg_total: 0.1 }
      ],
      'Murray, Grayson': [
        { year: 2024, finish: 'T25', sg_total: 0.0 }
      ],
      'Zalatoris, Will': [
        { year: 2025, finish: 'T22', sg_total: 0.1 },
        { year: 2024, finish: 'T4', sg_total: 0.1 },
        { year: 2023, finish: 'T53', sg_total: 0.1 },
        { year: 2022, finish: 'T38', sg_total: 0.1 },
        { year: 2021, finish: 'T10', sg_total: 0.1 }
      ],
      'Detry, Thomas': [
        { year: 2025, finish: 'CUT', sg_total: 0.1 },
        { year: 2023, finish: 'T24', sg_total: 0.1 }
      ],
      'Jones, Matt': [
        { year: 2022, finish: 'T52', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Frittelli, Dylan': [
        { year: 2022, finish: 'T42', sg_total: 0.1 },
        { year: 2021, finish: 'CUT', sg_total: 0.1 }
      ],
      'Greyserman, Max': [
        { year: 2025, finish: 'T22', sg_total: 0.3 }
      ],
      'Harrington, Padraig': [
        { year: 2023, finish: 'T53', sg_total: 0.0 },
        { year: 2022, finish: 'T42', sg_total: 0.0 },
        { year: 2021, finish: 'T31', sg_total: 0.0 }
      ],
      'Johnson, Zach': [
        { year: 2023, finish: 'T68', sg_total: 0.0 },
        { year: 2022, finish: 'T42', sg_total: 0.0 },
        { year: 2021, finish: 'T49', sg_total: 0.0 }
      ],
      'Hughes, Mackenzie': [
        { year: 2025, finish: 'T22', sg_total: 0.0 },
        { year: 2024, finish: 'T30', sg_total: 0.0 },
        { year: 2023, finish: 'T61', sg_total: 0.0 }
      ],
      'Steele, Brendan': [
        { year: 2022, finish: 'T26', sg_total: 0.0 },
        { year: 2021, finish: 'T18', sg_total: 0.0 }
      ],
      'McIlroy, Rory': [
        { year: 2025, finish: 'T15', sg_total: 0.1 },
        { year: 2024, finish: 'T21', sg_total: 0.1 },
        { year: 2023, finish: 'T2', sg_total: 0.1 },
        { year: 2022, finish: 'T13', sg_total: 0.1 },
        { year: 2021, finish: 'T10', sg_total: 0.1 }
      ],
      'Griffin, Ben': [
        { year: 2025, finish: 'T45', sg_total: 0.1 },
        { year: 2023, finish: 'T14', sg_total: 0.1 }
      ],
      'Aberg, Ludvig': [
        { year: 2025, finish: 'T22', sg_total: 0.1 },
        { year: 2024, finish: 'T25', sg_total: 0.1 },
        { year: 2023, finish: 'T24', sg_total: 0.1 }
      ],
      'Westwood, Lee': [
        { year: 2022, finish: 'T68', sg_total: 0.0 },
        { year: 2021, finish: '2', sg_total: 0.0 }
      ],
      'Suh, Justin': [
        { year: 2023, finish: 'T24', sg_total: 0.1 }
      ],
      'Rodgers, Patrick': [
        { year: 2025, finish: 'T22', sg_total: 0.0 },
        { year: 2024, finish: 'T25', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T38', sg_total: 0.0 },
        { year: 2021, finish: 'T57', sg_total: 0.0 }
      ],
      'An, Byeong Hun': [
        { year: 2025, finish: 'T8', sg_total: 0.0 },
        { year: 2024, finish: 'T8', sg_total: 0.0 },
        { year: 2023, finish: 'WD', sg_total: 0.0 },
        { year: 2021, finish: 'T43', sg_total: 0.0 }
      ],
      'Griffin, Lanto': [
        { year: 2022, finish: 'T52', sg_total: 0.1 },
        { year: 2021, finish: 'T21', sg_total: 0.1 }
      ],
      'Henley, Russell': [
        { year: 2025, finish: '1', sg_total: 0.0 },
        { year: 2024, finish: 'T4', sg_total: 0.0 },
        { year: 2023, finish: 'T53', sg_total: 0.0 },
        { year: 2022, finish: 'T13', sg_total: 0.0 }
      ],
      'Berger, Daniel': [
        { year: 2025, finish: 'T15', sg_total: 0.1 }
      ],
      'Hoffman, Charley': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T10', sg_total: 0.0 }
      ],
      'Koivun, Jackson': [
        { year: 2025, finish: 'T48', sg_total: -0.1 }
      ],
      'Na, Kevin': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T43', sg_total: 0.0 }
      ],
      'Taylor, Nick': [
        { year: 2025, finish: 'T31', sg_total: 0.0 },
        { year: 2024, finish: 'T12', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T32', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Perez, Pat': [
        { year: 2022, finish: 'T42', sg_total: 0.0 },
        { year: 2021, finish: 'T36', sg_total: 0.0 }
      ],
      'Novak, Andrew': [
        { year: 2025, finish: 'T34', sg_total: 0.2 }
      ],
      'Theegala, Sahith': [
        { year: 2025, finish: 'CUT', sg_total: 0.1 },
        { year: 2024, finish: 'T6', sg_total: 0.1 },
        { year: 2023, finish: 'T14', sg_total: 0.1 },
        { year: 2022, finish: 'CUT', sg_total: 0.1 }
      ],
      'Thompson, Davis': [
        { year: 2025, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'T53', sg_total: 0.0 },
        { year: 2022, finish: 'T42', sg_total: 0.0 }
      ],
      'Day, Jason': [
        { year: 2025, finish: 'T8', sg_total: 0.0 },
        { year: 2024, finish: 'T36', sg_total: 0.0 },
        { year: 2023, finish: 'T10', sg_total: 0.0 },
        { year: 2021, finish: 'T31', sg_total: 0.0 }
      ],
      'Gay, Brian': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Howell III, Charles': [
        { year: 2022, finish: 'T32', sg_total: 0.0 },
        { year: 2021, finish: 'T36', sg_total: 0.0 }
      ],
      'Poulter, Ian': [
        { year: 2022, finish: 'T42', sg_total: 0.0 },
        { year: 2021, finish: 'T26', sg_total: 0.0 }
      ],
      'Rose, Justin': [
        { year: 2025, finish: 'T8', sg_total: 0.0 },
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'WD', sg_total: 0.0 }
      ],
      'Hossler, Beau': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T20', sg_total: 0.0 }
      ],
      'Snedeker, Brandt': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T68', sg_total: 0.0 }
      ],
      'Ghim, Doug': [
        { year: 2022, finish: 'CUT', sg_total: 0.1 },
        { year: 2021, finish: 'T36', sg_total: 0.1 }
      ],
      'Eckroat, Austin': [
        { year: 2025, finish: 'T34', sg_total: 0.1 },
        { year: 2024, finish: 'T36', sg_total: 0.1 }
      ],
      'Moore, Taylor': [
        { year: 2024, finish: 'T48', sg_total: 0.0 },
        { year: 2023, finish: 'T39', sg_total: 0.0 },
        { year: 2022, finish: 'T42', sg_total: 0.0 }
      ],
      'Montgomery, Taylor': [
        { year: 2023, finish: 'T39', sg_total: 0.2 }
      ],
      'English, Harris': [
        { year: 2025, finish: 'CUT', sg_total: 0.0 },
        { year: 2024, finish: 'T21', sg_total: 0.0 },
        { year: 2023, finish: 'T2', sg_total: 0.0 },
        { year: 2021, finish: 'T26', sg_total: 0.0 }
      ],
      'Glover, Lucas': [
        { year: 2025, finish: 'T36', sg_total: 0.0 },
        { year: 2024, finish: 'T30', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T74', sg_total: 0.0 },
        { year: 2021, finish: 'T66', sg_total: 0.0 }
      ],
      'Young, Cameron': [
        { year: 2025, finish: 'CUT', sg_total: 0.1 },
        { year: 2024, finish: 'T36', sg_total: 0.1 },
        { year: 2023, finish: 'T10', sg_total: 0.1 },
        { year: 2022, finish: 'T13', sg_total: 0.1 }
      ],
      'Herron, Tim': [
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Swafford, Hudson': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Lee, K.H.': [
        { year: 2023, finish: 'T53', sg_total: 0.0 },
        { year: 2022, finish: 'T42', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Woodland, Gary': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T5', sg_total: 0.0 }
      ],
      'Hovland, Viktor': [
        { year: 2025, finish: 'CUT', sg_total: 0.0 },
        { year: 2024, finish: 'T36', sg_total: 0.0 },
        { year: 2023, finish: 'T10', sg_total: 0.0 },
        { year: 2022, finish: 'T2', sg_total: 0.0 },
        { year: 2021, finish: 'T49', sg_total: 0.0 }
      ],
      'Laird, Martin': [
        { year: 2023, finish: 'T39', sg_total: 0.0 },
        { year: 2022, finish: 'T52', sg_total: 0.0 },
        { year: 2021, finish: 'T43', sg_total: 0.0 }
      ],
      'Fleetwood, Tommy': [
        { year: 2025, finish: 'T11', sg_total: 0.0 },
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'T61', sg_total: 0.0 },
        { year: 2022, finish: 'T20', sg_total: 0.0 },
        { year: 2021, finish: 'T10', sg_total: 0.0 }
      ],
      'Fowler, Rickie': [
        { year: 2024, finish: 'T36', sg_total: 0.0 },
        { year: 2023, finish: 'T31', sg_total: 0.0 },
        { year: 2022, finish: 'T52', sg_total: 0.0 },
        { year: 2021, finish: '72', sg_total: 0.0 }
      ],
      'Hadwin, Adam': [
        { year: 2025, finish: 'T45', sg_total: 0.0 },
        { year: 2024, finish: 'T52', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Scott, Adam': [
        { year: 2025, finish: 'T36', sg_total: 0.0 },
        { year: 2024, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'T31', sg_total: 0.0 },
        { year: 2022, finish: 'T26', sg_total: 0.0 }
      ],
      'Clark, Wyndham': [
        { year: 2025, finish: 'T22', sg_total: 0.0 },
        { year: 2024, finish: '2', sg_total: 0.0 },
        { year: 2023, finish: 'T34', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Rai, Aaron': [
        { year: 2025, finish: 'T11', sg_total: 0.1 },
        { year: 2023, finish: 'T53', sg_total: 0.1 },
        { year: 2022, finish: 'CUT', sg_total: 0.1 }
      ],
      'Stanley, Kyle': [
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Sigg, Greyson': [
        { year: 2023, finish: 'T61', sg_total: 0.0 },
        { year: 2022, finish: 'T68', sg_total: 0.0 }
      ],
      'Varner III, Harold': [
        { year: 2021, finish: 'T21', sg_total: 0.0 }
      ],
      'Donald, Luke': [
        { year: 2023, finish: 'T39', sg_total: 0.0 }
      ],
      'McCarthy, Denny': [
        { year: 2025, finish: '18', sg_total: 0.0 },
        { year: 2024, finish: 'T48', sg_total: 0.0 },
        { year: 2022, finish: 'T61', sg_total: 0.0 },
        { year: 2021, finish: 'T26', sg_total: 0.0 }
      ],
      'Morikawa, Collin': [
        { year: 2025, finish: '2', sg_total: 0.1 },
        { year: 2024, finish: 'CUT', sg_total: 0.1 },
        { year: 2023, finish: 'CUT', sg_total: 0.1 }
      ],
      'Watney, Nick': [
        { year: 2022, finish: 'T20', sg_total: 0.0 }
      ],
      'Munoz, Sebastian': [
        { year: 2022, finish: 'T26', sg_total: 0.1 },
        { year: 2021, finish: 'T49', sg_total: 0.1 }
      ],
      'Horschel, Billy': [
        { year: 2025, finish: 'CUT', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T2', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'NeSmith, Matt': [
        { year: 2023, finish: 'T39', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Whaley, Vince': [
        { year: 2022, finish: 'T61', sg_total: -0.0 }
      ],
      'Cantlay, Patrick': [
        { year: 2025, finish: 'T31', sg_total: 0.1 },
        { year: 2024, finish: 'T36', sg_total: 0.1 },
        { year: 2023, finish: 'T4', sg_total: 0.1 }
      ],
      'Lower, Justin': [
        { year: 2024, finish: 'T36', sg_total: -0.0 },
        { year: 2023, finish: 'CUT', sg_total: -0.0 }
      ],
      'Wiesberger, Bernd': [
        { year: 2021, finish: 'T31', sg_total: 0.1 }
      ],
      'Simpson, Webb': [
        { year: 2024, finish: 'T30', sg_total: 0.0 },
        { year: 2023, finish: 'T24', sg_total: 0.0 }
      ],
      'Villegas, Camilo': [
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Spaun, J.J.': [
        { year: 2025, finish: 'T31', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T52', sg_total: 0.0 }
      ],
      'Stuard, Brian': [
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Wise, Aaron': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T17', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Burns, Sam': [
        { year: 2025, finish: 'T48', sg_total: 0.0 },
        { year: 2024, finish: 'T30', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T9', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Todd, Brendon': [
        { year: 2024, finish: 'T6', sg_total: 0.0 },
        { year: 2023, finish: 'T39', sg_total: 0.0 },
        { year: 2022, finish: '60', sg_total: 0.0 },
        { year: 2021, finish: 'T57', sg_total: 0.0 }
      ],
      'Wolff, Matthew': [
        { year: 2022, finish: 'T61', sg_total: 0.0 }
      ],
      'Thomas, Justin': [
        { year: 2025, finish: 'T36', sg_total: 0.1 },
        { year: 2024, finish: 'T12', sg_total: 0.1 },
        { year: 2023, finish: 'T21', sg_total: 0.1 }
      ],
      'Jaeger, Stephan': [
        { year: 2025, finish: 'CUT', sg_total: 0.0 },
        { year: 2024, finish: 'T44', sg_total: 0.0 },
        { year: 2022, finish: 'T52', sg_total: 0.0 }
      ],
      'Ortiz, Carlos': [
        { year: 2022, finish: 'CUT', sg_total: -0.0 }
      ],
      'Matsuyama, Hideki': [
        { year: 2025, finish: 'T22', sg_total: 0.0 },
        { year: 2024, finish: 'T12', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'T20', sg_total: 0.0 },
        { year: 2021, finish: 'T18', sg_total: 0.0 }
      ],
      'Kizzire, Patton': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T32', sg_total: -0.0 },
        { year: 2021, finish: 'T57', sg_total: -0.0 }
      ],
      'Thompson, Michael': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 }
      ],
      'Harman, Brian': [
        { year: 2025, finish: 'T40', sg_total: 0.0 },
        { year: 2024, finish: 'T12', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 }
      ],
      'Lowry, Shane': [
        { year: 2025, finish: '7', sg_total: 0.0 },
        { year: 2024, finish: '3', sg_total: 0.0 },
        { year: 2023, finish: '67', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Reed, Patrick': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'CUT', sg_total: 0.0 }
      ],
      'Casey, Paul': [
        { year: 2022, finish: '72', sg_total: 0.0 },
        { year: 2021, finish: 'T10', sg_total: 0.0 }
      ],
      'Herman, Jim': [
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Dufner, Jason': [
        { year: 2021, finish: 'T36', sg_total: 0.0 }
      ],
      'List, Luke': [
        { year: 2024, finish: '56', sg_total: 0.0 },
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T63', sg_total: 0.0 }
      ],
      'Lingmerth, David': [
        { year: 2023, finish: 'T70', sg_total: -0.0 }
      ],
      'Duncan, Tyler': [
        { year: 2021, finish: 'T57', sg_total: -0.1 }
      ],
      'McGreevy, Max': [
        { year: 2025, finish: 'T40', sg_total: 0.1 }
      ],
      'Finau, Tony': [
        { year: 2025, finish: 'T36', sg_total: 0.0 },
        { year: 2023, finish: 'T24', sg_total: 0.0 }
      ],
      'Tringale, Cameron': [
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T31', sg_total: 0.0 }
      ],
      'Cink, Stewart': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 }
      ],
      'Salinda, Isaiah': [
        { year: 2025, finish: 'T45', sg_total: -0.0 }
      ],
      'Streelman, Kevin': [
        { year: 2023, finish: 'CUT', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 }
      ],
      'Pan, C.T.': [
        { year: 2024, finish: '51', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Hodges, Lee': [
        { year: 2024, finish: 'T12', sg_total: -0.0 },
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 }
      ],
      'Ryder, Sam': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'T61', sg_total: -0.0 }
      ],
      'Redman, Doc': [
        { year: 2021, finish: 'T66', sg_total: -0.0 }
      ],
      'Stevens, Sam': [
        { year: 2025, finish: 'T40', sg_total: 0.1 }
      ],
      'Stricker, Steve': [
        { year: 2021, finish: 'T63', sg_total: -0.0 }
      ],
      'Huh, John': [
        { year: 2021, finish: 'T63', sg_total: -0.0 }
      ],
      'Noren, Alex': [
        { year: 2023, finish: 'T61', sg_total: 0.0 },
        { year: 2021, finish: 'T49', sg_total: 0.0 }
      ],
      'Davis, Cam': [
        { year: 2025, finish: 'CUT', sg_total: -0.0 },
        { year: 2024, finish: 'T18', sg_total: -0.0 },
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Kim, Si Woo': [
        { year: 2025, finish: 'T19', sg_total: -0.0 },
        { year: 2024, finish: 'T30', sg_total: -0.0 },
        { year: 2023, finish: 'T39', sg_total: -0.0 },
        { year: 2022, finish: 'T26', sg_total: -0.0 },
        { year: 2021, finish: 'WD', sg_total: -0.0 }
      ],
      'Goydos, Paul': [
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Cole, Eric': [
        { year: 2025, finish: 'T50', sg_total: -0.0 },
        { year: 2024, finish: 'T21', sg_total: -0.0 },
        { year: 2023, finish: 'CUT', sg_total: -0.0 }
      ],
      'Kisner, Kevin': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'T36', sg_total: -0.0 }
      ],
      'Cook, Austin': [
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Grace, Branden': [
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'T26', sg_total: -0.0 }
      ],
      'Van Rooyen, Erik': [
        { year: 2024, finish: 'T25', sg_total: 0.0 },
        { year: 2022, finish: 'CUT', sg_total: 0.0 },
        { year: 2021, finish: 'T57', sg_total: 0.0 }
      ],
      'Tway, Kevin': [
        { year: 2022, finish: 'CUT', sg_total: -0.1 }
      ],
      'Gordon, Will': [
        { year: 2023, finish: 'T70', sg_total: -0.1 },
        { year: 2021, finish: 'T49', sg_total: -0.1 }
      ],
      'Smalley, Alex': [
        { year: 2023, finish: 'CUT', sg_total: -0.1 },
        { year: 2022, finish: 'T38', sg_total: -0.1 }
      ],
      'Shelton, Robby': [
        { year: 2023, finish: 'T39', sg_total: -0.1 },
        { year: 2021, finish: 'CUT', sg_total: -0.1 }
      ],
      'Dahmen, Joel': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Buckley, Hayden': [
        { year: 2023, finish: 'CUT', sg_total: -0.1 },
        { year: 2022, finish: 'T68', sg_total: -0.1 }
      ],
      'Schauffele, Xander': [
        { year: 2025, finish: 'T40', sg_total: 0.1 },
        { year: 2024, finish: 'T25', sg_total: 0.1 },
        { year: 2023, finish: 'T39', sg_total: 0.1 }
      ],
      'Dunlap, Nick': [
        { year: 2025, finish: 'CUT', sg_total: -0.2 },
        { year: 2024, finish: 'T48', sg_total: -0.2 }
      ],
      'Perez, Victor': [
        { year: 2021, finish: 'T68', sg_total: -0.1 }
      ],
      'Stallings, Scott': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 }
      ],
      'McNealy, Maverick': [
        { year: 2025, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: '73', sg_total: -0.0 },
        { year: 2021, finish: 'T49', sg_total: -0.0 }
      ],
      'Palmer, Ryan': [
        { year: 2023, finish: 'T53', sg_total: -0.0 }
      ],
      'Malnati, Peter': [
        { year: 2023, finish: 'CUT', sg_total: -0.2 },
        { year: 2022, finish: 'CUT', sg_total: -0.2 },
        { year: 2021, finish: 'CUT', sg_total: -0.2 }
      ],
      'Knox, Russell': [
        { year: 2021, finish: '70', sg_total: -0.0 }
      ],
      'Straka, Sepp': [
        { year: 2025, finish: 'T5', sg_total: -0.0 },
        { year: 2024, finish: 'T57', sg_total: -0.0 },
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Sabbatini, Rory': [
        { year: 2022, finish: 'WD', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Hubbard, Mark': [
        { year: 2021, finish: 'T43', sg_total: -0.1 }
      ],
      'Rahm, Jon': [
        { year: 2023, finish: 'T39', sg_total: 0.2 },
        { year: 2022, finish: 'T17', sg_total: 0.2 }
      ],
      'Schwartzel, Charl': [
        { year: 2022, finish: 'CUT', sg_total: -0.0 },
        { year: 2021, finish: 'CUT', sg_total: -0.0 }
      ],
      'Janewattananond, Jazz': [
        { year: 2021, finish: 'T57', sg_total: -0.3 }
      ],
      'Power, Seamus': [
        { year: 2024, finish: 'T21', sg_total: -0.1 },
        { year: 2023, finish: '72', sg_total: -0.1 },
        { year: 2022, finish: 'CUT', sg_total: -0.1 }
      ],
      'Reavie, Chez': [
        { year: 2023, finish: 'CUT', sg_total: -0.0 },
        { year: 2022, finish: '77', sg_total: -0.0 },
        { year: 2021, finish: 'T49', sg_total: -0.0 }
      ],
      'Norlander, Henrik': [
        { year: 2022, finish: 'CUT', sg_total: -0.1 },
        { year: 2021, finish: '71', sg_total: -0.1 }
      ],
      'Kim, Tom': [
        { year: 2025, finish: 'CUT', sg_total: -0.0 },
        { year: 2024, finish: 'T52', sg_total: -0.0 },
        { year: 2023, finish: 'T34', sg_total: -0.0 }
      ],
      'Champ, Cameron': [
        { year: 2022, finish: 'T61', sg_total: -0.1 },
        { year: 2021, finish: 'CUT', sg_total: -0.1 }
      ],
      'Pendrith, Taylor': [
        { year: 2025, finish: 'CUT', sg_total: -0.1 },
        { year: 2023, finish: 'CUT', sg_total: -0.1 },
        { year: 2022, finish: 'T42', sg_total: -0.1 }
      ],
      'Gamez, Robert': [
        { year: 2021, finish: 'DQ', sg_total: -0.1 }
      ],
      'Hojgaard, Nicolai': [
        { year: 2024, finish: 'CUT', sg_total: -0.2 },
        { year: 2022, finish: 'CUT', sg_total: -0.2 }
      ],
      'Svensson, Adam': [
        { year: 2024, finish: 'CUT', sg_total: -0.1 },
        { year: 2023, finish: 'T24', sg_total: -0.1 },
        { year: 2022, finish: 'CUT', sg_total: -0.1 }
      ],
      'Byrd, Jonathan': [
        { year: 2022, finish: 'CUT', sg_total: -0.1 }
      ],
      'Pieters, Thomas': [
        { year: 2022, finish: 'T32', sg_total: -0.1 }
      ],
      'Lahiri, Anirban': [
        { year: 2022, finish: 'T74', sg_total: -0.1 },
        { year: 2021, finish: 'CUT', sg_total: -0.1 }
      ],
      'Higgo, Garrick': [
        { year: 2023, finish: 'CUT', sg_total: -0.5 },
        { year: 2022, finish: 'CUT', sg_total: -0.5 }
      ],
      'Streb, Robert': [
        { year: 2021, finish: 'CUT', sg_total: -0.2 }
      ],
      'Poston, J.T.': [
        { year: 2025, finish: 'T50', sg_total: -0.1 },
        { year: 2024, finish: '55', sg_total: -0.1 },
        { year: 2021, finish: 'CUT', sg_total: -0.1 }
      ],
      'Piercy, Scott': [
        { year: 2022, finish: 'CUT', sg_total: -0.1 }
      ],
      'Pavon, Matthieu': [
        { year: 2025, finish: 'CUT', sg_total: -0.3 },
        { year: 2024, finish: 'T52', sg_total: -0.3 }
      ],
      'Knapp, Jake': [
        { year: 2024, finish: 'T57', sg_total: -0.5 }
      ],
      'Lee, Min Woo': [
        { year: 2025, finish: 'CUT', sg_total: -0.2 },
        { year: 2024, finish: 'T44', sg_total: -0.2 },
        { year: 2023, finish: 'CUT', sg_total: -0.2 },
        { year: 2022, finish: 'CUT', sg_total: -0.2 }
      ]
    }
  }

};

// Helper function to get a golfer's history at a specific course
export function getGolferCourseHistory(golferName, tournamentId) {
  const tournament = COURSE_HISTORY[tournamentId];
  if (!tournament) return null;
  
  const history = tournament.golfers[golferName];
  if (!history) return null;
  
  return {
    courseName: tournament.courseName,
    history: history.sort((a, b) => b.year - a.year) // Most recent first
  };
}

// Calculate course form (average of last 3 years)
export function calculateCourseForm(history) {
  if (!history || history.length === 0) return null;
  
  const recentResults = history.slice(0, 3);
  const validResults = recentResults.filter(r => r.finish !== 'MC' && r.finish !== 'WD' && r.finish !== 'CUT');
  
  if (validResults.length === 0) return null;
  
  const avgSG = validResults.reduce((sum, r) => sum + r.sg_total, 0) / validResults.length;
  
  return {
    recentAppearances: recentResults.length,
    avgStrokesGained: avgSG,
    bestFinish: recentResults.reduce((best, r) => {
      if (r.finish === 'MC' || r.finish === 'WD' || r.finish === 'CUT') return best;
      const num = parseInt(r.finish.replace(/[^0-9]/g, ''));
      return !best || num < best ? num : best;
    }, null)
  };
}